import React from 'react';
import "../App.css"
import Navbar from '../Components/navbar';
import Sidebar from '../Components/sidebar';

const HomePage = () => {
    return (
        <div>
            <Navbar
                navTitle="SkyTracker"
                navLinkOneTitle="API" navLinkOneSource="/docs/api"
                navLinkTwoTitle="Pro" navLinkTwoSource="/pro"
                navLinkThreeTitle="Issues" navLinkThreeSource="/issues"
            />
              <Sidebar/>           
            

            
        </div>
    );
}; 



export default HomePage;